import React from 'react';


function Footer(){
    const currentYear = new Date().getFullYear();
    return(
        <div className="footer-container">
            <small>
            <p>&copy; {currentYear}  Eastern Pacific Academy</p>
            <p>Powered by: AHM</p>
            </small>
        </div>
    );
}
export default Footer;
